<template>
    <form @submit.prevent="storePayment()" v-show="show">
        <div class="modal_content p-15 m-0">
            <div class="row">
                <div class="col-sm-6 col-md-4 m_bottom_15" :class="{'has-error': errors['payment_method_id']}">
                    <label>{{ $t('payment_method') }}</label>
                    <pml-select v-model="payment_method" :options="paymentMethods" label="display_name"></pml-select>
                    <span class="error" v-if="errors['payment_method_id']">{{ errors['payment_method_id'][0] }}</span>
                </div>
                <div class="col-sm-6 col-md-4 m_bottom_15" :class="{'has-error': errors['installments']}">
                    <label>{{ $t('installments') }}</label>
                    <pml-select v-model="selectedInstallment" :options="installments" label="name"></pml-select>
                    <span class="error" v-if="errors['installments']">{{ errors['installments'][0] }}</span>
                </div>
                <div class="col-sm-6 col-md-4 m_bottom_15" :class="{'has-error': errors['value']}">
                    <label class="control-label">{{ $t('value') }}</label>
                    <label class="input-group">
                        <pml-numeric v-model="record.value" @blur="checkValue"></pml-numeric>
                        <span class="input-group-addon">{{ getCurrency(tenant.currency_id).symbol }}</span>
                    </label>
                    <span class="error" v-if="errors['value']">{{ errors['value'][0] }}</span>
                </div>
            </div>
            <div class="clearfix m_bottom_15">
                <div class="pull-right">
                    Remainig Value: 
                    {{ totalQuote - totalPayments | pmlFormatCurrencyById(tenant.currency_id) }}
                    <small class="show f_normal" v-if="tenant.currency_id != quotation.currency_id">
                        ({{ (totalQuote - totalPayments) * quotation.exchange_rate | pmlFormatCurrencyById(quotation.currency_id) }})
                    </small>
                </div>
            </div>
            <div class="clearfix">
                <button type="submit" @click.prevent="storePayment()" class="btn btn-default pull-right" v-pml-block="isSaving" :disabled="canAdd">{{ $t('add') }}</button>
            </div>
        </div>
        <table class="table table-striped table-bordered m-0">
            <thead>
                <tr>
                    <th>{{ $t('payment_method') }}</th>
                    <th>{{ $t('installments') }}</th>
                    <th>{{ $t('fee') }}</th>
                    <th>{{ $t('installment_value') }}</th>
                    <th>{{ $t('value') }}</th>
                    <th class="t_center w_100">{{ $t('actions') }}</th>
                </tr>
            </thead>
            <tbody>
                <PmlItem v-for="item in payments" :key="item.id" :item="item" :tenant="tenant" :quotation="quotation" @destroyItem="destroyItem"></PmlItem>
                <tr v-show="!payments.length">
                    <td class="t_center" colspan="6"><i class="fa fa-exclamation-triangle"></i> {{ $t('no_records_found') }}</td>
                </tr>
            </tbody>
        </table>
        <div class="modal_content p-15 m-0">
            <div class="clearfix">
                <span class="btn btn-white" @click.prevent="cancel()">{{ $t('cancel') }}</span>
                <button type="submit" @click.prevent="store()" class="btn btn-default pull-right" v-pml-block="isSaving" :disabled="(totalQuote - totalPayments) != 0">{{ $t('save') }}</button>
            </div>
        </div>
    </form>
</template>

<script>
    import Notify from 'utils/helpers/notify'
    import { trans } from 'utils/helpers/translation'
    import { create } from 'services/quotation-payments'
    import { findCurrency } from 'utils/helpers/find-store'
    import { mapGetters } from 'vuex'
    import PmlItem from './FormItem.vue'
    import TableFilters from 'utils/mixins/table-filters'
    import { find } from 'lodash'

    export default {
        name: 'QuotationAddPayment',
        mixins: [ TableFilters ],
        props: [ 'show' ],
        components: { PmlItem },
        data () {
            return {
                payment_method: '',
                record: {
                    payment_method_name: null,
                    payment_method_id: '',
                    installments: null,
                    value: 0,
                    fee: 0
                },
                payments: [],
                selectedInstallment: null,
                installments: [],
                records: [],
                errors: [],
                isSaving: false,
                loadingPayments: false,
                listConfig: {
                    orderProp: 'value',
                    orderDir: 'asc'
                }
            }
        },
        computed: {
            ...mapGetters({
                'tenant': 'getTenant',
                'paymentMethods': 'getPaymentMethods',
                'quotations': 'getDealQuotations'
            }),
            quotation () {
                return find(this.quotations, {id: parseInt(this.$route.params.quotation)}) || {}
            },
            canAdd () {
                return !this.record.payment_method_id || !this.selectedInstallment || !this.record.value
            },
            totalQuote () {
                return this.quotation.total_products + this.quotation.total_discounts + this.quotation.total_taxes
            },
            totalPayments () {
                return this.payments.reduce((sum, payment) => sum + payment.value, 0)
            }
        },
        watch: {
            'payment_method' (val) {
                if (val) {
                    this.record.payment_method_id = val
                    let paymentMethod = this.paymentMethods.find((item) => item.id === val)
                    this.record.payment_method_name = paymentMethod.display_name
                    this.installments = paymentMethod.payment_installments.map((item) => ({
                        id: item.id,
                        name: item.name
                    }))
                } else { this.installments = [] }
            },
            'selectedInstallment': function (val) {
                if (val) {
                    let paymentMethod = this.paymentMethods.find((item) => item.id === this.payment_method)
                    let installment = paymentMethod.payment_installments.find((item) => item.id === val)
                    if (installment) {
                        console.log(installment)
                        this.record.installments = installment.name
                        this.record.fee = installment.fee
                    }
                }
            }
        },
        methods: {
            getCurrency: (id) => findCurrency(id),
            store () {
                this.isSaving = true

                create(this.$route.params.id, this.$route.params.quotation, this.payments)
                    .then(() => {
                        this.clear()
                        this.errors = []
                        Notify.success(trans('the_record_has_been_saved'))
                    })
                    .catch(error => { this.errors = error.response.data.errors || [] })
                    .then(() => {
                        this.isSaving = false
                        this.payments = []
                        this.cancel()
                    })
            },
            storePayment () {
                this.isSaving = true
                this.payments.push(this.record)
                this.clear()
                this.isSaving = false
            },
            clear () {
                this.record = {
                    payment_method_name: null,
                    payment_method_id: '',
                    installments: null,
                    value: 0,
                    fee: 0
                }
                this.selectedInstallment = null
                this.payment_method = ''
                this.errors = []
            },
            cancel () {
                this.clear()
                this.$emit('close')
            },
            destroyItem (item) {
                this.payments = this.payments.filter(payment => {
                    return JSON.stringify(payment) !== JSON.stringify(item)
                })
            },
            checkValue () {
                if (this.record.value > (this.totalQuote - this.totalPayments))
                    this.record.value = this.totalQuote - this.totalPayments
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/modules/deals/components/show/quotations/edit/payments/Form.vue